import { useTranslation } from 'react-i18next';

import BooleanInputs from './BooleanInputs';
import Input from './Input';

interface Props {
  name: string;
  type: string;
  required: boolean;
}

const Question = ({ name, type, required }: Props) => {
  const { t } = useTranslation();

  switch (type) {
    case 'string':
      return <Input name={name} type="text" required={required} placeholder={t('forms.placeholders.string')} />;
    case 'integer':
      return <Input name={name} type="number" required={required} placeholder={t('forms.placeholders.integer')} />;
    case 'boolean':
      return <BooleanInputs name={name} required={required} />;
    case 'date':
      return <Input name={name} type="date" placeholder={t('forms.placeholders.date')} required={required} />;
    case 'datetime':
      return <Input name={name} type="time" placeholder={t('forms.placeholders.datetime')} required={required} />;
    default:
      return <Input name={name} type="text" placeholder={t('forms.placeholders.default')} required={required} />;
  }
};

export default Question;
